import React, { useState } from "react";
import { ChevronDown, Compass, Waves, Droplets, Flame, Wind, Snowflake, LayoutGrid, Coffee, Sparkles, RotateCw, Cog, Scissors, Package } from "lucide-react";
import { PRICING_CATEGORIES } from "@/data/feniks";

const ICONS = { Compass, Waves, Droplets, Flame, Wind, Snowflake, LayoutGrid, Coffee, Sparkles, RotateCw, Cog, Scissors, Package };

export default function Pricing() {
  const [openId, setOpenId] = useState("diagnostyka");

  return (
    <section
      id="cennik"
      data-testid="pricing-section"
      className="bg-white border-t border-zinc-200 py-20 md:py-28"
    >
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="mb-12">
          <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[var(--feniks-red)] mb-3">
            [03] Cennik
          </div>
          <h2 data-testid="pricing-headline" className="font-display text-3xl md:text-4xl lg:text-5xl leading-none tracking-tighter mb-4">
            Stały cennik usług.
          </h2>
          <p className="text-zinc-600 max-w-2xl">
            Przejrzyste, stałe stawki za prace serwisowe. Do podanych cen należy doliczyć koszt
            części. Wybierz kategorię, aby zobaczyć szczegóły.
          </p>
        </div>

        <div className="border border-zinc-200">
          {PRICING_CATEGORIES.map((cat) => {
            const Icon = ICONS[cat.icon] || Cog;
            const isOpen = openId === cat.id;
            return (
              <div key={cat.id} className="border-b last:border-b-0 border-zinc-200">
                <button
                  data-testid={`pricing-toggle-${cat.id}`}
                  onClick={() => setOpenId(isOpen ? null : cat.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-7 py-5 md:py-6 text-left hover:bg-zinc-50 transition-colors group"
                  aria-expanded={isOpen}
                >
                  <div className="flex items-center gap-4 min-w-0">
                    <div className={`shrink-0 w-10 h-10 flex items-center justify-center border transition-colors ${
                      isOpen ? "border-[var(--feniks-red)] bg-[var(--feniks-red)] text-white" : "border-zinc-300 text-zinc-700 group-hover:border-zinc-900"
                    }`}>
                      <Icon size={18} />
                    </div>
                    <div className="min-w-0">
                      <div className="font-display text-lg md:text-xl tracking-tight truncate">{cat.title}</div>
                      <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mt-0.5">
                        {cat.items.length} {cat.items.length === 1 ? "pozycja" : "pozycji"}
                      </div>
                    </div>
                  </div>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 transition-transform ${isOpen ? "rotate-180 text-[var(--feniks-red)]" : "text-zinc-500"}`}
                  />
                </button>

                {isOpen && (
                  <div data-testid={`pricing-content-${cat.id}`} className="border-t border-zinc-200 bg-zinc-50">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="text-left text-[10px] tracking-[0.2em] uppercase text-zinc-500">
                          <th className="px-5 md:px-7 py-3 font-medium">Usługa</th>
                          <th className="px-5 md:px-7 py-3 font-medium text-right">Cena</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cat.items.map((it, i) => (
                          <tr key={i} className="border-t border-zinc-200">
                            <td className="px-5 md:px-7 py-3.5 text-zinc-800">{it.service}</td>
                            <td className="px-5 md:px-7 py-3.5 text-right font-mono font-semibold text-zinc-900 whitespace-nowrap">
                              {it.price}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <p className="text-xs text-zinc-500 mt-6 font-mono">
          * Do podanych cen należy doliczyć koszt części.
        </p>
      </div>
    </section>
  );
}
